import { useState } from "react";
import { providerLabel, versionLabel } from "../musicMetadata.js";
import { Icon } from "./Media.jsx";

/** 歌詞版本的展開、搜尋與候選切換集中在此，播放器只管理選擇結果。 */
export default function LyricsPicker({
  candidates,
  selectedId,
  onSelect,
  query,
  onQueryChange,
  onSearch,
  searching,
}) {
  const [open, setOpen] = useState(false);
  const selected = candidates.find((candidate) => candidate.candidateId === selectedId);

  return (
    <section className={`lyrics-picker ${open ? "is-open" : ""}`} aria-label="選擇歌詞版本">
      <button className="lyrics-picker__toggle" type="button"
        onClick={() => setOpen((value) => !value)} aria-expanded={open}>
        <span className="lyrics-picker__summary">
          <strong>歌詞版本</strong>
          <small>{searching ? "正在尋找歌詞…" :
            selected ? `${selected.sourceLabel || providerLabel(selected.provider)} · ${selected.synchronized ? "同步 LRC" : "純文字"}` :
              `${candidates.length} 個結果`}</small>
        </span>
        <span className="lyrics-picker__arrow"><Icon name="chevronDown" size={16}/></span>
      </button>
      <div className="lyrics-picker__body" hidden={!open}>
        <form className="lyrics-search" onSubmit={onSearch}>
          <Icon name="search" size={16}/>
          <input value={query} onChange={(event) => onQueryChange(event.target.value)}
            placeholder="搜尋同步 LRC、歌名或歌手" aria-label="搜尋歌詞版本" />
          <button disabled={searching}>{searching ? <span className="spinner"/> : "搜尋 LRC"}</button>
        </form>
        <div className="lyrics-options">
          {candidates.length ? candidates.map((candidate) => (
            <button key={candidate.candidateId} type="button"
              className={selectedId === candidate.candidateId ? "active" : ""}
              onClick={() => onSelect(candidate)}>
              <span className="lyrics-radio">{selectedId === candidate.candidateId ? "●" : "○"}</span>
              <span className="lyrics-option-copy">
                <strong>{candidate.automatic ? "自動匹配" : "其他版本"} · {candidate.title}</strong>
                <span>{(candidate.artists || []).join("／") || "未知歌手"}</span>
                <small>{candidate.sourceLabel || providerLabel(candidate.provider)} · {versionLabel(candidate.versionType)} · {candidate.synchronized ? "同步 LRC" : "純文字"} · {candidate.lineCount} 行</small>
              </span>
            </button>
          )) : <p className="lyrics-no-results">{searching ? "正在搜尋歌詞…" : "沒有找到可用歌詞"}</p>}
        </div>
      </div>
    </section>
  );
}
